import { makeVar, useReactiveVar } from "@apollo/client";

export const accountTypeVariable = makeVar<string>("HI");

export const useUserRole = () => useReactiveVar(accountTypeVariable);
